<template>
    <div>
        <b-row>
            <b-col cols="12">
                <b-tabs 
                nav-class="nav-tabs-custom"
                style="border: 1px solid lightgrey; border-radius: 0.rem;"
                content-class="p-3 text-muted">
                    <b-tab active>
                        <template v-slot:title>
                            <span class="d-inline-block d-sm-none">
                                <i class="far fa-user"></i>
                            </span>
                            <span class="d-none d-sm-inline-block">Step</span>
                        </template>
                        <div class="card-body tabBody">
                            <div v-if="client_step_data.render_type == 'custom'">
                                <component @back="backEvent" :is="stepComponent"/>
                            </div>
                            <div v-else-if="client_step_data.render_type == 'simple'">
                                <component  @back="backEvent" :is="stepComponent"/>
                            </div>
                        </div>
                    </b-tab>

                    <b-tab>
                        <template v-slot:title>
                            <span class="d-inline-block d-sm-none">
                                <i class="far fa-user"></i>
                            </span>
                            <span class="d-none d-sm-inline-block">Comments</span>
                        </template>
                        <div class="card-body tabBody">
                            <Chat />
                        </div>
                    </b-tab>

                    <b-tab>
                        <template v-slot:title>
                            <span class="d-inline-block d-sm-none">
                                <i class="far fa-user"></i>
                            </span>
                            <span class="d-none d-sm-inline-block">Validation</span>
                        </template>
                        <div class="card-body tabBody">
                            <b-overlay :show="isLoading">
                                <b-row>
                                    <!--<b-col cols="12"><h5>Forms</h5></b-col>-->
                                    <b-col v-for="(item, idx) in validationItems" :key="idx" cols="4">

                                        <b-card
                                        :header-class="valid(isValid(item.id)) ? 'border-success' : 'border-danger'"
                                        :class="valid(isValid(item.id)) ? 'bg-success border-success' : 'bg-danger border-danger'"
                                        class="border">
                                            <template v-slot:header>
                                                <h5 v-if="valid(isValid(item.id))" class="my-0 text-dark">
                                                    <!--<i class="fas fa-thumbs-up me-3"></i>-->
                                                    {{item.requirement}}
                                                </h5>
                                                <h5 v-else class="my-0 text-dark">
                                                    <!--<i class="fas fa-thumbs-down me-3"></i>-->
                                                    {{item.requirement}}
                                                </h5>
                                            </template>

                                            <!-- action buttons -->
                                            <b-button size="lg" v-if="!valid(isValid(item.id))" @click="setValidation('passed', item.id)" variant="success">
                                                <i class="fas fa-thumbs-up me-1"></i>
                                                Pass
                                            </b-button>
                                            <b-button size="lg" v-if="valid(isValid(item.id))" @click="setValidation('failed', item.id)" variant="danger">
                                                <i class="fas fa-thumbs-down me-1"></i>
                                                Fail
                                            </b-button>
                                        </b-card>
                                    </b-col>
                                </b-row>
                            </b-overlay>
                        </div>
                    </b-tab>

                    <b-tab v-if="hasMedia">
                        <template v-slot:title>
                            <span class="d-inline-block d-sm-none">
                                <i class="far fa-user"></i>
                            </span>
                            <span class="d-none d-sm-inline-block">Media</span>
                        </template>
                        <div class="card-body tabBody">
                            <b-row v-if="client_step_data.length > 0"> 
                                <b-col cols="3" v-for="item in client_step_data.media" :key="item.id">
                                    <div class="p-2" style="border: 1px solid lightgrey">
                                        {{item}}
                                    </div>
                                </b-col>
                            </b-row>
                            <b-row v-else>
                                <b-col cols="12">
                                    <b-alert :show="true">
                                        This Step Has No Media
                                    </b-alert>
                                </b-col>
                            </b-row>
                        </div>
                    </b-tab>

                    <b-tab>
                        <template v-slot:title>
                            <span class="d-inline-block d-sm-none">
                                <i class="far fa-user"></i>
                            </span>
                            <span class="d-none d-sm-inline-block">Tasks</span>
                        </template>
                        <div class="card-body tabBody">
                            <Tasks/>
                        </div>
                    </b-tab>
                </b-tabs>
                
            </b-col>
        </b-row>
    </div>
</template>

<script>

import { ccbAdminState, ccbAdminMethods } from '@/state/helpers'
import Tasks from './tasks.vue'
import Chat from './chat.vue'
import _ from 'lodash'
export default {
    components:{
        Chat, Tasks
    },
    data:() => ({
        isLoading: false,
        value: 'test'
    }),
    computed:{
        ...ccbAdminState,
        stepComponent() {
            let component = '';

            if(this.client_step_data.render_type == 'simple'){
                component = 'Simple'
            }
            else{
                component = this.client_step_data.custom_render_component_name;
            }
            return () => import(`@/components/admin/applicants/renderComponents/${component}`);
            //}
        },
        validationItems(){
            if(this.client_step_data != null){
                return this.client_step_data.validation;
            }
            else{
                return []
            }
        },
        hasMedia(){
            let valid = false;
            if(this.client_step_data != null){
                if(this.client_step_data.media.length > 0){
                    valid = true;
                }
            }

            return valid;
        }
    },
    methods:{
        ...ccbAdminMethods,
        backEvent(){
            this.$emit('backEvent');
        },
        setValidation(type, id){
            if(type == 'failed'){
                //* Show message box for rejection message
                this.$swal.fire({
                    title: 'Reason for failure',
                    input: 'text',
                    inputValue: '',
                })
                .then((result) => {
                    console.log(result, id);
                    if(result.isConfirmed){
                        /* Send the client a message */
                        let params = {
                            client_id: this.client_data.client.id,
                            step_id: this.client_step_data.id,
                            body: result.value,
                            step_validation: '',
                            due_date: '',
                            task_user_id: '',
                            type: 'admin_comment',
                        }
                        this.addComment(params)
                        .then(()=>{
                            this.applyValidationType(type, id);
                        })
                    }
                })
            }
            else{
                //* No need for message if step passes validation
                this.applyValidationType(type, id);
            }
        },
        applyValidationType(type, id){
            this.isLoading = true;
            let params = {
                client_id: this.client_data.client.id,
                validation_status: type,
                validation_check_id: id
            }
            this.validateStep(params)
            .then(()=>{
                this.reloadStepData();
            })
            .catch(()=>{
                this.isLoading = false;
            })
        },
        isValid(id){
            let style = 'validation-invalid';
            if(this.client_step_data.status != 'pending_validation' && this.client_step_data.status != 'pending_revalidation'){
                let index = _.findIndex(this.client_step_data.validation, {id:id});
                if(index != -1){
                    
                    let validation_index = _.findIndex(this.client_step_data.validation[index].client_validation, {step_validation_id:id});
                    if(validation_index != -1){
                        let status = this.client_step_data.validation[index].client_validation[validation_index].validation_status;
                        if(status == 'passed'){
                            style = "validation-valid";
                        }
                    }
                }
            }
            return style;
        },
        valid(string){
            if(string === 'validation-valid'){
                return true;
            } 
            else{
                return false;
            }
        },

        reloadStepData(){
            let params = {
                client_id: this.client_data.client.id,
                step_id: this.client_step_data.id
            }
            //* refresh step to reflect validation changes
            this.loadClientStepData(params)
            .then(()=>{
                //* refresh the list of steps for the client
                this.loadClientData(this.client_data.client.id);
                this.isLoading = false;
            })
            .catch(()=>{
                this.isLoading = false;
            })
        }
    },
    mounted(){},
}
</script>

<style>
.validation-valid{
    color: limegreen;
}
.validation-invalid{
    color: red;
}
</style>